import UserSettingsIsland from "../ts/components/user/UserSettingsIsland";
import AdminUsersIsland from "../ts/components/user/AdminUsersIsland";
export default async function onUserPage(ctx) {
    void ctx;
    await mountUserSettingsIsland();
    await mountAdminUsersIsland();
}
async function mountUserSettingsIsland() {
    const settingsContainer = document.getElementById('user-settings-root');
    if (settingsContainer) {
        try {
            const { createRoot } = await import('react-dom/client');
            const React = await import('react');
            const root = createRoot(settingsContainer);
            root.render(React.createElement(UserSettingsIsland));
        }
        catch (error) {
            console.error('Failed to mount user settings island:', error);
        }
    }
}
async function mountAdminUsersIsland() {
    const adminContainer = document.getElementById('admin-users-root');
    if (adminContainer) {
        try {
            const { createRoot } = await import('react-dom/client');
            const React = await import('react');
            const root = createRoot(adminContainer);
            root.render(React.createElement(AdminUsersIsland));
        }
        catch (error) {
            console.error('Failed to mount admin users island:', error);
        }
    }
}
